const zh_CN = {
            'title':"学历认证系统",
            'preMessage':"欢迎使用澳门理工大学学历认证系统！请按证明书/毕业证书所载数据输入相关内容以进行认证。如有特别情况，欢迎透过电邮与本校招生注册处联系（电邮：registry@mpu.edu.mo；电话：+853-8599 6111/6103）。",
            'form.studName' :"学生姓名",
            'form.studName.placeholder' :"请输入姓名，你可输入中文或外文；若中文姓名為繁体，请使用右方转换功能。",
            'form.dob' :"出生日期 (YYYY/MM/DD)",
            'form.studName.placeholder' :"请输入姓名，你可输入中文或外文姓名",
            'form.studName.hints' :"请确认所输入的学生姓名与 证明书/毕业证书 上所示一致",
            'form.dob.placeholder' :"YYYY/MM/DD",
            'form.status':"文件类别",
            'form.status.current':"证明书",
            'form.status.graduate':"毕业证书",
            'form.gradYear':"毕业年份 (YYYY)",
            'form.gradYear.placeholder':"YYYY",
            'form.qual':"学歴",
            'form.qual.a':"A",
            'form.qual.b':"B",
            'form.qual.c':"C",
            'form.prog':"修读之课程",
            'form.certNo':"证明书/毕业证书编号",
            'form.submit':"认证",
            'form.modify':"修改",
            'form.reset':"重新认证",
            'form.hints':"*必须填写所有栏位",
            'result.title':"结果",
            'result.success':"兹确认　阁下所输入的数据与系统中的记录一致无误。",
            'result.fail':"兹确认　阁下所输入的数据与系统中的记录不一致。请重新输入或与招生注册处联系。",
            'server.error':"系统错误，请重新整理网页。",
            'convertTC':"转换为繁体",
            'form.error.required':"请输入这个栏位",
            'form.error.isDate':"请输入正确日期格式",
            'form.error.radio.required':"请选择一个",
        }
export default zh_CN;


// WEBPACK FOOTER //
// ./src/i18n/zh_CN.js